import PhotoSwipeLightbox from 'https://unpkg.com/photoswipe/dist/photoswipe-lightbox.esm.js';

document.addEventListener("DOMContentLoaded", () => { 
        const isMobile = window.innerWidth <= 768; // mobile breakpoint

        document.querySelectorAll('.desktop-zoom-hover').forEach(wrapper => {
          const img = wrapper.querySelector(".zoom-image:not(.hover_blur)");
          if (!img) return;
          if (!isMobile) {
            // ---------------- DESKTOP HOVER ZOOM ----------------
            let active = false;
            wrapper.addEventListener("mouseenter", () => { 
              active = true; 
              img.style.transition = "transform 0.5s ease"; 
              img.style.transform = "scale(1.8)"; 
            });
            wrapper.addEventListener("mousemove", (e) => { 
              if (!active) return; 
              const rect = wrapper.getBoundingClientRect(); 
              const x = e.clientX - rect.left; 
              const y = e.clientY - rect.top; 
              const px = Math.min(Math.max(0, x), rect.width); 
              const py = Math.min(Math.max(0, y), rect.height); 
              img.style.transformOrigin = `${px}px ${py}px`; 
            });
            wrapper.addEventListener("mouseleave", () => { 
              active = false; 
              img.style.transition = "transform 0.5s ease"; 
              img.style.transform = "scale(1) translate(0,0)"; 
            });
          } else {
            // ---------------- MOBILE TOUCH ZOOM ----------------
            let zoomed = false;
            let lastScale = 1;
            let startScale = 1;
            let startDistance = 0;
            let startX = 0;
            let startY = 0;
            let currentX = 0;
            let currentY = 0;
            let touchMoved = false;
            let touchStartClientX = 0;
            let touchStartClientY = 0;

            const gallery = wrapper.closest('media-gallery');

            const getBounds = (scale) => {
              const w = wrapper.clientWidth || wrapper.offsetWidth || (img && img.clientWidth) || 0;
              const h = wrapper.clientHeight || wrapper.offsetHeight || (img && img.clientHeight) || 0;
              const maxX = Math.max(0, (w * (scale - 1)) / 2);
              const maxY = Math.max(0, (h * (scale - 1)) / 2);
              return { maxX, maxY };
            };

            const resetZoom = (smooth) => {
              zoomed = false;
              wrapper.classList.remove('zoom-active');
              lastScale = 1;
              currentX = 0;
              currentY = 0;
              img.style.transformOrigin = 'center center';
              img.style.transition = smooth ? 'transform 0.3s ease' : 'none';
              img.style.transform = 'translate(0px, 0px) scale(1)';
              gallery?.resumeFromZoom();
            };

            wrapper.addEventListener("click", (e) => {
              e.preventDefault();
              if (touchMoved) {
                touchMoved = false;
                return;
              }

              if (!zoomed) {
                zoomed = true;
                wrapper.classList.add("zoom-active");

                gallery?.pauseFromZoom(); // 🛑 STOP AUTOPLAY

                lastScale = 2;
                currentX = 0;
                currentY = 0;
                img.style.transformOrigin = 'center center';
                img.style.transition = "transform 0.3s ease";
                img.style.transform = `translate(0px, 0px) scale(${lastScale})`;
              } else {
                resetZoom(true);
              }
            });

            wrapper.addEventListener("touchstart", (e) => {
              if (e.touches.length === 2) {
                // pinch start
                startDistance = Math.hypot(
                  e.touches[0].clientX - e.touches[1].clientX,
                  e.touches[0].clientY - e.touches[1].clientY
                );
                startScale = lastScale;
                touchMoved = true;
              } else if (e.touches.length === 1) {
                touchMoved = false;
                touchStartClientX = e.touches[0].clientX;
                touchStartClientY = e.touches[0].clientY;
                if (zoomed) {
                  startX = e.touches[0].clientX - currentX;
                  startY = e.touches[0].clientY - currentY;
                }
              }
            }, { passive: false });

            wrapper.addEventListener("touchmove", (e) => {
              if (!zoomed) return;
              e.preventDefault();

              if (e.touches.length === 2) {
                // pinch zoom
                const distance = Math.hypot(
                  e.touches[0].clientX - e.touches[1].clientX,
                  e.touches[0].clientY - e.touches[1].clientY
                );
                const scaleChange = distance / (startDistance || 1);
                const newScale = Math.min(Math.max(startScale * scaleChange, 1), 5); // limit zoom
                lastScale = newScale;

                // Dynamically clamp pan offsets so zooming out cannot reveal background
                const bounds = getBounds(newScale);
                currentX = Math.min(Math.max(currentX, -bounds.maxX), bounds.maxX);
                currentY = Math.min(Math.max(currentY, -bounds.maxY), bounds.maxY);

                img.style.transition = "none";
                img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${newScale})`;
              } else if (e.touches.length === 1) {
                // drag
                if (Math.hypot(e.touches[0].clientX - touchStartClientX, e.touches[0].clientY - touchStartClientY) > 5) {
                  touchMoved = true;
                }

                const bounds = getBounds(lastScale);
                const rawX = e.touches[0].clientX - startX;
                const rawY = e.touches[0].clientY - startY;

                // Clamp currentX so image never reveals background
                if (rawX > bounds.maxX) {
                  currentX = bounds.maxX;
                  startX = e.touches[0].clientX - bounds.maxX;
                } else if (rawX < -bounds.maxX) {
                  currentX = -bounds.maxX;
                  startX = e.touches[0].clientX + bounds.maxX;
                } else {
                  currentX = rawX;
                }

                // Clamp currentY so image never reveals background
                if (rawY > bounds.maxY) {
                  currentY = bounds.maxY;
                  startY = e.touches[0].clientY - bounds.maxY;
                } else if (rawY < -bounds.maxY) {
                  currentY = -bounds.maxY;
                  startY = e.touches[0].clientY + bounds.maxY;
                } else {
                  currentY = rawY;
                }

                img.style.transition = "none";
                img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${lastScale})`;
              }
            }, { passive: false });

            wrapper.addEventListener("touchend", (e) => {
              if (e.touches.length === 0 && zoomed) {
                if (lastScale <= 1.05) {
                  resetZoom(true);
                } else {
                  const bounds = getBounds(lastScale);
                  currentX = Math.min(Math.max(currentX, -bounds.maxX), bounds.maxX);
                  currentY = Math.min(Math.max(currentY, -bounds.maxY), bounds.maxY);
                  img.style.transition = "transform 0.2s ease";
                  img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${lastScale})`;
                }
              } else if (e.touches.length === 1 && zoomed) {
                startX = e.touches[0].clientX - currentX;
                startY = e.touches[0].clientY - currentY;
                touchStartClientX = e.touches[0].clientX;
                touchStartClientY = e.touches[0].clientY;
              }
            });

            if (gallery) {
              const viewer = gallery.querySelector('slider-component') || gallery;
              viewer.addEventListener('slideChanged', () => {
                if (zoomed) resetZoom(false);
              });
            }
          }
          wrapper.addEventListener('click', e => e.preventDefault());
        });
      });

      const isMobileLightbox = window.innerWidth <= 768; 
      if (!isMobileLightbox) {
        // Custom Arrow SVG
        const leftArrowSVGString = `
          <svg aria-hidden="true" class="pswp__icn" viewBox="0 0 100 125" width="100" height="125">
            <path d="M5,50L50,5l3,3L11,50l42,42l-3,3L5,50z M92,95l3-3L53,50L95,8l-3-3L47,50L92,95z"/>
          </svg>
        `;

        const lightbox = new PhotoSwipeLightbox({
          gallery: '.product__media-list',
          children: '.desktop-zoom-hover',
          pswpModule: () => import('https://unpkg.com/photoswipe'),
          arrowPrevSVG: leftArrowSVGString,
          arrowNextSVG: leftArrowSVGString,
          bgOpacity: 1,
          mouseMovePan: true,
          initialZoomLevel: 'fit',
          secondaryZoomLevel: 1.2,
          maxZoomLevel: 1,
          showHideAnimationType: 'fade',
          showAnimationDuration: 500,
          hideAnimationDuration: 500,
          mainClass: 'pswp--custom-icon-colors'
        });

        lightbox.on('uiRegister', () => {
          lightbox.pswp.ui.registerElement({
            name: 'bulletsIndicator',
            className: 'pswp__bullets-indicator',
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
              const bullets = [];
              let prevIndex = -1;
              for (let i = 0; i < pswp.getNumItems(); i++) {
                const bullet = document.createElement('div');
                bullet.className = 'pswp__bullet';
                bullet.onclick = (evt) => { pswp.goTo(bullets.indexOf(evt.target)); };
                el.appendChild(bullet);
                bullets.push(bullet);
              }
              pswp.on('change', () => {
                if (prevIndex >= 0) bullets[prevIndex].classList.remove('pswp__bullet--active');
                bullets[pswp.currIndex].classList.add('pswp__bullet--active');
                prevIndex = pswp.currIndex;
              });
            }
          });
        });

        lightbox.init();
        let autoSlideInterval;
        function startAutoplay() {
          autoSlideInterval = setInterval(() => {
            const pswp = lightbox.pswp;
            let nextIndex = pswp.currIndex + 1;
            if (nextIndex >= pswp.getNumItems()) nextIndex = 0;
            pswp.goTo(nextIndex);
          }, 10000);
        }
        lightbox.on('change', () => { clearInterval(autoSlideInterval); startAutoplay(); });
        lightbox.on('close', () => { clearInterval(autoSlideInterval); });
        lightbox.on('open', startAutoplay);
      }